import {
  Globe,
  Megaphone,
  Settings,
  Network,
  TrendingUp,
} from "lucide-react";

const objectives = [
  {
    title: "Establish",
    desc: "A synergistic network for MSMEs, national government, ministries, financial institutes, MSME promotion agencies, and international organizations.",
    icon: Globe,
  },
  {
    title: "Promote",
    desc: "National and international cooperation for MSMEs through policy advocacy, information dissemination, events, technology transfer, trainings and related activities.",
    icon: Megaphone,
  },
  {
    title: "Setup",
    desc: "WASME as a strategic resource centre for facilitating networking, business meetings, financial assistance, technology transfer, and entrepreneurship development.",
    icon: Settings,
  },
  {
    title: "Create Mechanism",
    desc: "Building structured linkages between MSMEs, government ministries, financial institutions, and international organizations.",
    icon: Network,
  },
  {
    title: "Be a Catalyst",
    desc: "Enabling MSMEs to become competitive, environment-friendly, socially responsible, culturally sensitive, and ethical in business practices.",
    icon: TrendingUp,
  },
];

export default function WASMEObjectives() {
  return (
    <section className="bg-[#f4f8fb] py-20">
      <div className="max-w-6xl mx-auto px-4">
        <h2 className="text-4xl font-semibold text-center text-[#1f4f7a] mb-14 tracking-wide">
          WASME OBJECTIVES
        </h2>

        <div className="relative space-y-10">
          {/* Vertical Line */}
          <div className="absolute left-7 top-0 bottom-0 w-[2px] bg-[#1f4f7a]/30"></div>

          {objectives.map((item, index) => {
            const Icon = item.icon;
            return (
              <div
                key={index}
                className="relative flex gap-6 bg-white border border-[#1f4f7a]/10 p-6 rounded-lg hover:shadow-md transition"
              >
                {/* Icon */}
                <div className="z-10 w-14 h-14 rounded-full bg-[#1f4f7a] flex items-center justify-center text-white">
                  <Icon size={26} />
                </div>

                {/* Content */}
                <div>
                  <h3 className="text-xl font-semibold text-[#1f4f7a] mb-2">
                    {item.title}
                  </h3>
                  <p className="text-gray-700 leading-relaxed text-sm md:text-base">
                    {item.desc}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
